import React from 'react';
import { ArrowUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { OrdersSortThProps } from './OrdersSortTh.types';

export const OrdersSortTh: React.FC<OrdersSortThProps> = ({
  col,
  sortCol,
  onSort,
  children,
  className,
}) => {
  return (
    <th
      className={cn(
        'px-3 py-2.5 text-left text-[10px] font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 cursor-pointer select-none whitespace-nowrap hover:text-slate-700 dark:hover:text-slate-300 transition-colors',
        className
      )}
      onClick={() => onSort(col)}
    >
      <span className="inline-flex items-center gap-1">
        {children}
        <ArrowUpDown
          className={cn(
            'w-3 h-3',
            sortCol === col ? 'text-indigo-500' : 'text-slate-300 dark:text-slate-600'
          )}
        />
      </span>
    </th>
  );
};
